/* Copyright (c) 2013 BambooHR, LLC
 *
 *
 * This search control was built to support a rich content search that did not
 * work with other jQuery auto-complete/live search products available.
 *
 * There were several requirements that made building our own tool necessary.
 * The solution to nearly all of these problems was to do the bulk of the work
 * on the server side and return fully formatted HTML results to the client.
 *
 *   1. Unicode accent folding.  Javascript doesn't support this other than with
 *      crude hard-coded maps.  We wanted to use Unicode collation and searching.
 *
 *   2. Global search.  Search multiple sections at once and then display
 *      the results of all sections simultaneously.
 *
 *   3. Pinned permutation search.  Typing in a series of words separated by
 *      spaces of all permutations of various fields that contain those words.
 *
 *   4. Advanced layout.  Most tools iterate over a single list of <li> tags.
 *      We wanted to be able to categorize the data into an inner <li> and an
 *      outer <li>.
 *
 *   5. Fast.  We want the user to see the result almost instanteously.  We
 *      accept some network latency, but we want the results from the server
 *      to display with minimal post processing.
 *
 *   6. Advanced searches based on patterns.  Client can not assume that a
 *      given result is a subset of any previous search.
 *
 */

(function () {
	const JADE_ENABLED = window.BambooHR.FeatureToggle.isEnabled('jade');

	let whatCreatedBlur; // Keeps track of any element that created a blur event to happen
	$.fn.bhrLiveSearch = function (options) {
		const input = this;
		const $input = $(input);
		const settings = $.extend(
			{
				result: '.js-globalResults',
				url: '/ajax/globalsearch.php',
				loader: JADE_ENABLED
					? `<div class="dotLoader">
					<div class="bounce1"></div>
					<div class="bounce2"></div>
					<div class="bounce3"></div>
				</div>`
					: '<img class="gLoader" src="/images/loader3.gif">',
			},
			options
		);

		let currentRequest = null;
		let el;
		let lastQuery = '';
		let lastShown = 0;
		let num = 0;
		let visible = false;
		let additionalparams = {};

		function hideSearch() {
			$(settings.result).hide();
			visible = false;
		}

		function next() {
			if ($(`${settings.result} li.selected`).length === 0) {
				$(`${settings.result} li li:first`).addClass('selected');
			} else {
				const original = $(settings.result).find('li.selected');
				el = original.next();
				if (el.length === 0) {
					el = original.parent().closest('li').next().find('li:first');
					if (el.length === 0) {
						el = original.parent().parent().parent().find('li:first').find('li:first');
					}
				}
				if (el.length === 1) {
					el.addClass('selected');
					original.removeClass('selected');
					$(el).get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
				}
			}
		}

		function prev() {
			const original = $(`${settings.result} li.selected`);
			el = original.prev();
			if (el.length === 0) {
				el = original.parent().closest('li').prev().find('li:last');
				if (el.length === 0) {
					el = original.parent().parent().parent().find('li:last');
				}
			}
			if (el.length === 1) {
				el.addClass('selected');
				original.removeClass('selected');
				$(el).get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
			}
		}

		function search(str, section) {
			lastQuery = str;
			if ($.trim(str) === '') {
				hideSearch();
			} else {
				const loadedNum = ++num;
				if (!visible) {
					$(settings.result).html(settings.loader).show();
					visible = true;
				}
				if (currentRequest !== null) {
					// for fast typers no point in listening for a prev request if you are going to make a new one
					currentRequest.abort();
				}

				if (options.getAdditionalParams && typeof options.getAdditionalParams === 'function') {
					additionalparams = options.getAdditionalParams();
				}

				currentRequest = $.post(
					settings.url,
					{
						q: str,
						section: section,
						...additionalparams,
					},
					function (data) {
						if (loadedNum > lastShown) {
							lastShown = loadedNum;
							if ($.trim(data) === '') {
								hideSearch();
							} else {
								var $container = $(settings.result);

								$container.html(data);

								if (options.prepend && typeof options.prepend === 'function') {
									options.prepend($container);
								}

								$container.show();

								if (data.indexOf('js-bhr-live-search-empty-results') > -1) {
									$input.trigger('bhrLiveSearch:emptyResults');
								} else {
									$input.trigger('bhrLiveSearch:nonEmptyResults');
									if ($(`${settings.result} li.selected`).length === 0) {
										$(`${settings.result} li li:first`).addClass('selected');
									}
								}
								visible = true;
							}
						}
					},
					'html'
				);
			}
		}

		$(document).on('mousemove', `${settings.result} ul ul li`, function () {
			$(`${settings.result} .selected`).removeClass('selected');
			$(this).addClass('selected');
		});

		$(document)
			.on('click', `${settings.result} ul ul li`, function () {
				$(`${settings.result} .selected`).removeClass('selected');
				$(this).addClass('selected');
			})
			.on('click', `${settings.result} .gSectionName`, function (e) {
				if (typeof settings.expandSection !== 'undefined' && settings.expandSection === true) {
					search(lastQuery, $(this).data('section-name'));
				}
			})
			.on('click', null, function (e) {
				if (!$(e.target).hasClass('globalsearch') && !$(e.target).hasClass('gResults--persist')) {
					hideSearch();
				}
			});

		return this.each(function () {
			$(this)
				.keyup(function (e) {
					if (e.keyCode !== 13 && e.keyCode !== 40 && e.keyCode !== 38 && e.keyCode !== 27) {
						search(this.value);
					}
				})
				.keydown(function (e) {
					if (e.keyCode === 13) {
						const selected = $('.js-globalResults .selected');
						if (selected.length > 0) {
							e.preventDefault();
							currentRequest.abort();
							hideSearch();
							window.location.href = $('.js-globalResults .selected')
								.attr('onclick')
								.replace(/location=\'(.*)\'/i, '$1');
						}
					} else if (e.keyCode === 27) {
						hideSearch();
					} else if (e.keyCode === 40) {
						e.preventDefault();
						if (visible) {
							next();
						} else {
							search(this.value);
						}
					} else if (e.keyCode === 38) {
						e.preventDefault();
						if (visible) {
							prev();
						} else {
							search(this.value);
						}
					}
				})
				.focus(function () {
					if (this.value !== '') {
						search(this.value);
					}
				})
				.blur(function () {
					// On blur (tab away or click outside) hide the search
					if (!$(whatCreatedBlur).hasClass('globalsearch') && $(whatCreatedBlur).closest('.js-globalResults').length === 0) {
						hideSearch();
					}
				});
		});
	};
	$(function () {
		// Track the latest element that was clicked
		$(document).mousedown(function (e) {
			whatCreatedBlur = $(e.target);
		});

		// When 'whatCreatedBlur == null' on blur, we know it was not caused by a click but maybe by pressing the tab key
		$(document).mouseup(function () {
			whatCreatedBlur = null;
		});
	});
})();
